import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../Event/event';
export default function PrimeCompositeSmash() {
  const [level, setLevel] = useState(20);
  const [currentNumber, setCurrentNumber] = useState(0);
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [streak, setStreak] = useState(0);
  const [bestStreak, setBestStreak] = useState(0);
  const [gameState, setGameState] = useState('start'); // start | playing | over
  const [feedback, setFeedback] = useState('');
  const [feedbackType, setFeedbackType] = useState('');

  const smashSound = new Audio("https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg");
  const correctSound = new Audio("https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg");
  const wrongSound = new Audio("https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg");

  const isComposite = (n) => {
    if (n < 2) return false;
    for (let i = 2; i <= Math.sqrt(n); i++) {
      if (n % i === 0) return true;
    }
    return false;
  };

  const getRandomNumber = (max) => Math.floor(Math.random() * max) + 1;

  const showNumber = () => {
    const num = getRandomNumber(level);
    setCurrentNumber(num);
    setFeedback('');
  };

  const startGame = () => {
    setScore(0);
    setLives(3);
    setStreak(0);
    setBestStreak(0);
    setGameState('playing');
    showNumber();
  };

  const endGame = () => {
    setGameState('over');
  };

  const handleCorrect = (message) => {
    correctSound.play();
    const newScore = score + 1;
    const newStreak = streak + 1;
    setScore(newScore);
    setStreak(newStreak);
    setBestStreak(Math.max(bestStreak, newStreak));
    setFeedback(message);
    setFeedbackType('success');
    setTimeout(showNumber, 1000);
  };

  const handleWrong = (message) => {
    wrongSound.play();
    const newLives = lives - 1;
    setLives(newLives);
    setStreak(0);
    setFeedback(message);
    setFeedbackType('danger');
    if (newLives <= 0) {
      setTimeout(endGame, 1000);
    } else {
      setTimeout(showNumber, 1000);
    }
  };

  const smash = () => {
    smashSound.play();
    if (isComposite(currentNumber)) {
      handleCorrect("🎯 You are right! That’s Composite!");
    } else {
      handleWrong("❌ Oops! That’s a Prime!");
    }
  };

  const skip = () => {
    if (!isComposite(currentNumber)) {
      handleCorrect("✅ You are right! That’s Prime!");
    } else {
      handleWrong("🚫 Incorrect! That’s Composite!");
    }
  };

  useEffect(() => {
    if (gameState === 'start') {
      setFeedback('');
    }

    if(gameState === 'over'||gameState=== 'playing'){
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  }, [gameState]);

  return (
    <div style={{
      fontFamily: 'Arial',
      textAlign: 'center',
      padding: '5vw 3vw',
      background: 'linear-gradient(270deg, #f0f8ff, #e6f7ff, #d0f0c0)',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <h2 style={{ marginBottom: '5vw', fontSize: 'clamp(1.5rem, 4vw, 2.5rem)' }}>🔢 Prime vs. Composite Smash!</h2>

      {gameState === 'start' && (
        <div>
          <label htmlFor="level" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.5rem)' }}>Choose Level:</label>
          <select
            id="level"
            value={level}
            onChange={(e) => setLevel(parseInt(e.target.value))}
            style={{ marginLeft: 10, padding: 8, fontSize: 'clamp(1rem, 2vw, 1.2rem)' }}>
            <option value="20">Easy (1–20)</option>
            <option value="50">Medium (1–50)</option>
            <option value="100">Hard (1–100)</option>
          </select>
          <br />
          <button
            onClick={startGame}
            style={{
              marginTop: '5vw',
              padding: '1rem 2rem',
              fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: 10
            }}>
            Start Game
          </button>
        </div>
      )}

      {gameState === 'playing' && (
        <>
          <div style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)', marginBottom: '3vw' }}>
            <strong>Score:</strong> {score} | <strong>Lives:</strong> {lives} | <strong>Best Streak:</strong> {bestStreak}
          </div>

          <div style={{
            fontSize: 'clamp(2rem, 10vw, 4rem)',
            border: '4px solid #2e8b57',
            display: 'inline-block',
            padding: '5vw 8vw',
            borderRadius: 20,
            backgroundColor: 'white',
            marginBottom: '5vw'
          }}>{currentNumber}</div>

          <div>
            <button
              onClick={smash}
              style={{
                margin: '3vw',
                padding: '1rem 2rem',
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                backgroundColor: '#2196f3',
                color: 'white',
                border: 'none',
                borderRadius: 10
              }}>🔨 Smash</button>

            <button
              onClick={skip}
              style={{
                margin: '3vw',
                padding: '1rem 2rem',
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                backgroundColor: '#ff9800',
                color: 'white',
                border: 'none',
                borderRadius: 10
              }}>🚫 Skip</button>
          </div>

          {feedback && (
            <div style={{
              marginTop: '4vw',
              fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
              color: feedbackType === 'success' ? '#2e7d32' : '#c62828'
            }}>{feedback}</div>
          )}
        </>
      )}

      {gameState === 'over' && (
        <div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)' }}>💀 Game Over!</h2>
          <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.3rem)' }}>Your Score: {score}</p>
          <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.3rem)' }}>Best Streak: {bestStreak}</p>
          <button
            onClick={() => setGameState('start')}
            style={{
              padding: '1rem 2rem',
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: 10
            }}>🔁 Restart</button>
        </div>
      )}
    </div>
  );
}
